export function target() {
  return this.module === 'PhotosMosaic' && this.data.images;
}

export function migrate() {
  this.data.media = this.data.images.map((image) => ({
    ...image,
    type: 'image',
  }));

  delete this.data.images;
}
